import PaymentMethodField from "../../components/Finance/PaymentMethodField"
import { useState } from "react"
import { X } from "lucide-react"
import { motion, AnimatePresence } from "framer-motion"
import { createExpense } from "../../api/products/post"

type Props = {
  storeId: any
  isOpen: boolean
  onClose: () => void
  onAdd: (expense: any) => void
}

export default function AddExpenseModal({
  storeId,
  isOpen,
  onClose,
  onAdd,
}: Props) {
  const [type, setType] = useState("")
  const [amount, setAmount] = useState("")
  const [description, setDescription] = useState("")
  const [paymentMethod, setPaymentMethod] = useState("CASH")
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState("")

  const handleSubmit = async () => {
    if (saving) return
    if (!type.trim() || !Number.isFinite(Number(amount)) || Number(amount) <= 0) { setError("Un type et un montant positif sont requis");return }
    setSaving(true);setError("")
    try {
      const expense = await createExpense(storeId,{ type,description,amount:Number(amount),paymentMethod,expenseDate:new Date() })
      onAdd(expense);setType("");setAmount("");setDescription("");onClose()
    } catch (err:any) { setError(err.message || "Impossible d'enregistrer la dépense") }
    finally { setSaving(false) }
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="bg-white rounded-2xl shadow-xl w-full max-w-md p-6 space-y-6"
            initial={{ scale: 0.9, y: 40 }}
            animate={{ scale: 1, y: 0 }}
            exit={{ scale: 0.9, y: 40 }}
          >
            {/* Header */}
            <div className="flex justify-between items-center">
              <h2 className="text-lg font-semibold">
                Ajouter une dépense
              </h2>
              <button onClick={onClose}>
                <X />
              </button>
            </div>

            {error && (
              <div className="bg-red-50 text-red-600 text-sm p-2 rounded-lg">
                {error}
              </div>
            )}

            <div className="space-y-4">
              <div>
                <label className="text-sm text-gray-600">
                  Type *
                </label>
                <input
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                  placeholder="Ex: Loyer, Transport…"
                  className="w-full border rounded-xl px-3 py-2"
                />
              </div>

              <div>
                <label className="text-sm text-gray-600">
                  Montant (FCFA) *
                </label>
                <input
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  className="w-full border rounded-xl px-3 py-2"
                />
              </div>

              <div>
                <label className="text-sm text-gray-600">
                  Description
                </label>
                <textarea
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  className="w-full border rounded-xl px-3 py-2"
                />
              </div>
            </div>

            <PaymentMethodField value={paymentMethod} onChange={setPaymentMethod} disabled={saving} />
            <div className="flex justify-end gap-3">
              <button
                onClick={onClose}
                className="px-4 py-2 rounded-xl border"
              >
                Annuler
              </button>
              <button
                onClick={handleSubmit}
                disabled={saving}
                className="px-4 py-2 rounded-xl bg-blue-600 text-white hover:bg-blue-700"
              >
                {saving ? "Enregistrement…" : "Enregistrer"}
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
